// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3CVru","errorLogs":"styles_errorLogs__1bENC"};